import React, { useRef, useState, useCallback } from "react";
import * as Scrivito from "scrivito";
import { Container } from "reactstrap";
import { ObjValidator, XCircleLoader } from "components";
import { ProjectHeader } from "components/ProjectHeader/ProjectHeader";
import { useNavigateToProject } from "hooks/projectHooks";
import { PROJECT_CONFIGURATOR_TAB_TYPES } from "variables";
import { ProjectItemProperties } from "./SubComponents/ProjectItemProperties";
import { ProjectItemUploads } from "./SubComponents/ProjectItemUploads";
import { ProjectSummary } from "./SubComponents/ProjectSummary";
import {
  useIsProjectLoading,
  useProject,
} from "stores/project/project/projectStore";
import type { ProductListRefValue } from "interfaces/product/product.types";
import type { ObjValidatorProps } from "interfaces/shared.types";

import s from "./ProjectItem.module.scss";

type ProjectItemProps = {
  page: Scrivito.Obj;
};

const ProjectItem = Scrivito.connect(({ page }: ProjectItemProps) => {
  const isLoading = useIsProjectLoading();
  const project = useProject();
  const [activeTab, setActiveTab] = useState<string>(
    PROJECT_CONFIGURATOR_TAB_TYPES.PRODUCT_LIST,
  );
  const navigateToProject = useNavigateToProject();

  const productListRef = useRef<ProductListRefValue | null>(null);

  const handleChangeActiveTab = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      setActiveTab(e.currentTarget.id);
    },
    [],
  );

  if (isLoading) return <XCircleLoader />;

  return (
    <>
      <div className="bg-gray-100">
        <Container className="py-5_5">
          <div className="d-flex justify-content-between w-100">
            <div className="d-flex justify-content-between align-items-center gap-4 mb-1">
              <ProjectHeader page={page} productListRef={productListRef} />
            </div>
            <div className="d-flex align-items-center gap-2"></div>
          </div>
          <h4 className={s.textWrap}>{project?.title}</h4>
        </Container>
      </div>
      <ProjectItemProperties />
      <ProjectSummary
        onRedirectToConfiguratorClick={() => {
          if (project?.id) {
            navigateToProject.configurator(project.id);
          }
        }}
        productListRef={productListRef}
        activeTab={activeTab}
        handleChangeActiveTab={handleChangeActiveTab}
      />
      <ProjectItemUploads />
    </>
  );
});

const CheckedPage = (props: ObjValidatorProps) => (
  <ObjValidator {...props} page={props.page}>
    {props.page ? <ProjectItem page={props.page} /> : null}
  </ObjValidator>
);
export default CheckedPage;
Scrivito.provideComponent("ProjectItem", CheckedPage);
